/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { UiModule } from '../../core/ui/ui.module';
import { PipeModule } from '../shared/pipes/pipe.module';
import { ChooseSearchDialogComponent } from './choose/choose-search-dialog.component';
import { CriteriaFormComponent } from './criteria/criteria-form.component';
import { SearchCriteriaDialogComponent } from './criteria/search-criteria-dialog.component';
import { SearchResultsComponent } from './results/search-results.component';
import { RouterModule } from '@angular/router';
import { PrintSearchComponent } from './results/print/print-search.component';
import { SearchResultsPrintComponent } from './results/print/search-results-print.component';
import { SearchResultsContentComponent } from './results/search-results-content.component';
import { SearchCriteriaCardComponent } from './criteria/search-criteria-card.component';
import { ZoomButtonModule } from '../../core/ui/zoomButton/zoom-button.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [
        SearchCriteriaDialogComponent,
        ChooseSearchDialogComponent,
        SearchResultsComponent,
        CriteriaFormComponent,
        PrintSearchComponent,
        SearchResultsPrintComponent,
        SearchResultsContentComponent,
        SearchCriteriaCardComponent,
    ],
    exports: [
        CriteriaFormComponent,
        SearchCriteriaCardComponent,
        SearchResultsContentComponent,
        SearchResultsPrintComponent,
    ],
    imports: [
        SharedModule,
        RouterModule,
        PipeModule,
        UiModule,
        ZoomButtonModule,
    ],
})
export class SearchModule {
}
